import styled from "styled-components";
import { TextField } from "@mui/material";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";

import { InputUnformPropsI } from "./InputUnform.component";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-family: Averta PE;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #d20e0e;
    margin-top: 16px;
  }
`;

export const InputLabel = styled.label<{ enabled?: boolean }>`
  color: ${(props) => {
    if (!props.enabled) {
      return "#A3AFD1";
    }
    return "#1B2852";
  }};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  padding-bottom: 16px;
`;

export const InputStyled = styled(TextField)<InputUnformPropsI>`
  & label.Mui-focused {
    color: white;
  }

  & .MuiOutlinedInput-root {
    background-color: ${(props) => (props.filled ? "#F3F6FF" : "")};
    border: ${(props) => (props.filled ? "1px solid #D9DFF8" : "")};
    font-family: "AvertaPE";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
    & .MuiOutlinedInput-input {
      font-family: "AvertaPE";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.15000000596046448px;
      text-align: left;
      color: #1b2852;
    }
    &.Mui-disabled input {
      cursor: not-allowed;
    }
    &.Mui-focused fieldset {
      border: 1px solid #a3afd1;
    }
  }
`;

export const CircularProgressStyled = styled(
  CircularProgress
)<CircularProgressProps>({
  color: "white",
});
